import apiClient from "./client";

// fetch one form by ID
export function fetchForm(id) {
  return apiClient.get(`/forms/${encodeURIComponent(id)}`).then((res) => res.data);
}

export function fetchFormsAll() {
  return apiClient.get(`/forms`).then((res) => res.data);
}

// create a brand-new form
export function createForm(payload) {
  // payload: { name: string, formStructure: string }
  return apiClient.post("/forms", payload).then((res) => res.data);
}

// update an existing form
export function updateForm(id, payload) {
  return apiClient.put(`/forms/${encodeURIComponent(id)}`, payload).then((res) => res.data);
}

export function deleteForm(id) {
  return apiClient.delete(`/forms/${encodeURIComponent(id)}`).then((res) => {
    // DELETE typically returns 204 No Content, so res.data might be empty
    // Axios should still return the response object even for 204
    return res.status === 204 || res.status === 200 ? { success: true } : res.data;
  }).catch((err) => {
    throw err;
  });
}

export function fetchFormsDropdown() {
  return apiClient.get("/forms/dropdown").then((res) => res.data);
}

// The defaults library (Customer 0 presets) offered by "Add from Defaults".
// These are pick-list only — a customer never uses one directly.
export function fetchFormPresets() {
  return apiClient.get("/forms/presets").then((res) => res.data);
}

// Copy a default into the current customer as a brand new, independent form.
// The copy keeps no reference back to the default it came from.
export function copyFormPreset(presetFormId, name = null) {
  return apiClient
    .post(`/forms/presets/${encodeURIComponent(presetFormId)}/copy`, { name })
    .then((res) => res.data);
}
